import { useAuth0 } from '@auth0/auth0-react'
import {
  HStack,
  Flex,
  Box,
  IconButton,
  Image,
  Text,
  Spacer,
  useMediaQuery
} from '@chakra-ui/react'
import { format, parseISO } from 'date-fns'
import { FC } from 'react'
import { AiOutlineTeam, AiOutlineProfile } from 'react-icons/ai'
import { ImExit } from 'react-icons/im'
import { useHistory } from 'react-router-dom'

import useAuth from '@hook/shared/use-auth'
import useFilters from '@hook/shared/use-filters'
import useLayout from '@hook/shared/use-layout'

import LayoutNavigator from './Navigator'
import HeaderProfile from './Profile'

const LayoutHeader: FC = () => {
  const { menuToggle } = useLayout()
  const { role } = useAuth()
  const history = useHistory()
  const { dailyProcess } = useFilters()
  const [isMobile] = useMediaQuery('(max-width: 768px)')
  const { logout } = useAuth0()

  if (!localStorage.getItem('APP_VERSION')) {
    localStorage.setItem('APP_VERSION', '0.0.0')
    window.location.reload()
  }

  return (
    <Box bg="white">
      {!menuToggle && (
        <>
          <Flex
            maxW={1022}
            marginX="auto"
            alignItems="center"
            justifyContent="flex-start"
            paddingY={[2, 3, 3]}
            paddingRight="1rem"
            paddingLeft="0.5rem"
          >
            <Box>
              <Image src="/assets/images/logo.svg" w="64px" mr="auto" />
              <Text marginLeft={1.5} fontSize="10px" color="gray.500">
                {dailyProcess.status !== ''
                  ? (!isMobile ? 'Dados atualizados em ' : 'Atualizado') +
                    format(
                      parseISO(dailyProcess.dataFim.toString()),
                      'dd/MM/yyyy HH:mm'
                    )
                  : 'Não há dados sobre a ultima atualização'}
              </Text>
              <Text marginLeft={1.5} fontSize="7px" color="gray.500">
                {dailyProcess.status !== ''
                  ? (!isMobile ? 'Version ' : 'Version ') +
                    localStorage.getItem('APP_VERSION')
                  : 'Não há dados sobre a ultima versao'}
              </Text>
              <Text marginLeft={1.5} fontSize="7px" color="gray.500">
                GCP
              </Text>
            </Box>
            <Spacer></Spacer>
            <HStack spacing={2} mr={[4, 4, 6]}>
              <>
                {/* {(role === 'Administrador' ||
                  role === 'AnalistaPlanejamento')&& (
                  <IconButton
                    aria-label="Time"
                    height={['2.2rem', '2.5rem', '2.5rem']}
                    width={['2.2rem', '2.5rem', '2.5rem']}
                    borderRadius={50}
                    icon={<AiOutlineSetting />}
                    color="#1d5840"
                    bgColor="gray.100"
                    fontSize="18px"
                    transition="all ease .3s"
                    onClick={() => history.push('/usuarios')}
                    isRound
                    _hover={{
                      bgColor: 'gray.300'
                    }}
                    _active={{
                      bgColor: 'gray.300'
                    }}
                  />
                )} */}
                {(role === 'Administrador' ||
                  role === 'AnalistaPlanejamento') && (
                  <IconButton
                    aria-label="Time"
                    height={['2.2rem', '2.5rem', '2.5rem']}
                    width={['2.2rem', '2.5rem', '2.5rem']}
                    borderRadius={50}
                    icon={<AiOutlineTeam />}
                    color="#1d5840"
                    bgColor="gray.100"
                    fontSize="18px"
                    transition="all ease .3s"
                    onClick={() => history.push('/usuarios')}
                    isRound
                    _hover={{
                      bgColor: 'gray.300'
                    }}
                    _active={{
                      bgColor: 'gray.300'
                    }}
                  />
                )}
                {(role === 'Administrador' ||
                  role === 'AnalistaPlanejamento') && (
                  <IconButton
                    aria-label="Calendário"
                    size="md"
                    height={['2.2rem', '2.5rem', '2.5rem']}
                    width={['2.2rem', '2.5rem', '2.5rem']}
                    icon={<AiOutlineProfile />}
                    color="#1d5840"
                    bgColor="gray.100"
                    fontSize="18px"
                    onClick={() => history.push('/perfil')}
                    transition="all ease .3s"
                    isRound
                    _hover={{
                      bgColor: 'gray.300'
                    }}
                    _active={{
                      bgColor: 'gray.300'
                    }}
                  />
                )}
              </>
            </HStack>

            <HeaderProfile />

            <Box pl={4}>
              <IconButton
                aria-label="Time"
                height={['1.7rem', '2rem', '2rem']}
                width={['1.7rem', '2rem', '2rem']}
                borderRadius={10}
                icon={<ImExit width="20%" />}
                color="#1d5840"
                bgColor="red.100"
                fontSize="18px"
                transition="all ease .3s"
                onClick={() => logout({ returnTo: window.location.origin })}
                isRound
                _hover={{
                  bgColor: 'red.300'
                }}
                _active={{
                  bgColor: 'red.300'
                }}
              />
            </Box>
          </Flex>

          <LayoutNavigator />
        </>
      )}
    </Box>
  )
}

export default LayoutHeader
